import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { wrapper, stepWrapper, stepIndicatorWrapper, stepIndicator, stepHeader, stepContent } from './styles.js';
import { IconCheck } from '../icons/ui_control/IconCheck.web.js';
import { useTheme } from '../utils/theming/useTheme.js';

var Stepper = function Stepper(_ref) {
  var _ref$orientation = _ref.orientation,
      orientation = _ref$orientation === void 0 ? 'vertical' : _ref$orientation,
      align = _ref.align,
      _ref$steps = _ref.steps,
      steps = _ref$steps === void 0 ? [] : _ref$steps,
      wrapperClassName = _ref.wrapperClassName,
      colorProp = _ref.color,
      props = _objectWithoutProperties(_ref, ["orientation", "align", "steps", "wrapperClassName", "color"]);

  var theme = useTheme();
  var stepperTheme = theme.stepper.web;
  var color = colorProp ? colorProp : stepperTheme.color;
  return (
    /*#__PURE__*/
    React.createElement(wrapper, _extends({
      "data-test": "elemental-Stepper",
      className: wrapperClassName,
      layout: orientation
    }, props), steps.map(function (step, index) {
      return (
        /*#__PURE__*/
        React.createElement(stepWrapper, _extends({
          "data-test": "elemental-Stepper-".concat(step.id),
          key: step.id,
          className: step.stepClassName,
          valid: step.valid,
          layout: orientation,
          numSteps: steps.length,
          color: color,
          theme: theme,
          align: align || stepperTheme.align
        }, step.stepProps),
        /*#__PURE__*/
        React.createElement(stepIndicatorWrapper, {
          layout: orientation,
          align: (align || stepperTheme.align) === 'center' ? 'center' : 'start'
        },
        /*#__PURE__*/
        React.createElement(stepIndicator, {
          layout: orientation,
          valid: step.valid,
          inactive: step.inactive,
          color: color,
          theme: theme
        }, step.valid ?
        /*#__PURE__*/
        React.createElement(IconCheck, {
          color: stepperTheme.step.iconColor,
          size: 24
        }) : index + 1)), step.header &&
        /*#__PURE__*/
        React.createElement(stepHeader, {
          inactive: step.inactive,
          layout: orientation,
          theme: theme,
          style: {
            textAlign: orientation === 'horizontal' ? align || stepperTheme.align : undefined
          }
        }, step.header), orientation === 'vertical' &&
        /*#__PURE__*/
        React.createElement(stepContent, null, step.content), orientation === 'horizontal' && !step.inactive &&
        /*#__PURE__*/
        React.createElement(stepContent, {
          width: "".concat(steps.length * 100, "%"),
          left: "-".concat(index * 100, "%")
        }, step.content))
      );
    }))
  );
};

export { Stepper };